import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@jana-technology/platform-ui";
import type { RiskAssetFilterItemSelectProps } from "./types";
import {
  keepStrings,
  stripTypenameField,
} from "contexts/filters/risk-management-filters";

export const RiskAssetFilterItemSelect = ({
  items,
  id,
  label,
  baseFilters,
  stateKey,
  stateItems,
  setState,
}: RiskAssetFilterItemSelectProps) => {
  const itemIsString = typeof stateItems[0] === "string";

  const selectFilterValue =
    stateItems.length === baseFilters[stateKey].length
      ? "all"
      : itemIsString
        ? (stateItems[0] as string)
        : String((stateItems[0] as { id: number; value: string }).id);

  return (
    <div>
      <label htmlFor={id} className="sr-only">
        {label}
      </label>
      <Select
        value={selectFilterValue}
        onValueChange={(value) => {
          const isAll = value === "all";

          // added statekey check to guard against number values
          if (itemIsString && stateKey === "wellTypes") {
            setState((state) => ({
              ...state,
              [stateKey]: isAll
                ? baseFilters.wellTypes.filter(keepStrings)
                : [value],
            }));
          }

          const numValue = Number(value);

          // we are toggling between number/strings (due to select type limitations)
          if (stateKey === "riskQuartiles") {
            setState((prev) => ({
              ...prev,
              [stateKey]: isAll
                ? baseFilters.riskQuartiles.map(stripTypenameField)
                : baseFilters.riskQuartiles
                    .filter((q) => q.id === numValue)
                    .map(stripTypenameField),
            }));
          }
        }}
      >
        <SelectTrigger className="w-full" id={id}>
          <SelectValue placeholder="Select one" />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value="all">All</SelectItem>
          {items.map((item) => (
            <SelectItem key={item.value} {...item} />
          ))}
        </SelectContent>
      </Select>
    </div>
  );
};

export default RiskAssetFilterItemSelect;
